module.exports = __webpack_public_path__ + "media/logos/zapier-833a13ef.png";